<div id="appId" style="overflow: hidden;">
<app-spinner [blockedPanel]='blockedPanel'></app-spinner>
<router-outlet>

</router-outlet>
</div>